import type { HttpError } from "../../http-error";
import type { UnsupportedContentTypeError } from "../unsupported-content-type.error";

export function isUnsupportedContentTypeError(
  error: HttpError,
): error is UnsupportedContentTypeError {
  return error.isUnsupportedContentTypeError;
}
